// Mock Data für Dion Hair Clinic - Barthaartransplantation Landing Page

export const variant = "bart";
export const variantLabel = "Barthaartransplantation";

export const clinicInfo = {
  name: "Dion Hair Clinic",
  tagline: "Ihr Experte für Barthaartransplantation",
  phone: "+49 2161 2963017",
  email: "info@dionhairclinic.de",
  website: "www.dionhairclinic.de",
  address: {
    street: "Schürenweg 61",
    city: "41063 Mönchengladbach",
    country: "Deutschland"
  },
  openingHours: {
    weekdays: "Mo - Fr: 9:00 - 18:00 Uhr",
    saturday: "Sa: 10:00 - 14:00 Uhr",
    sunday: "So: Geschlossen"
  }
};

export const heroContent = {
  title: "Barthaartransplantation",
  subtitle: "Für Ihren Traumbart",
  description: "Ein voller, dichter Bart symbolisiert für viele Männer Männlichkeit und Selbstbewusstsein. Mit FUE und DHI Techniken transplantieren wir Haarfollikel präzise für ein natürliches Aussehen. Ob Vollbart, Lückenfüllung oder Konturgestaltung – wir entwickeln die ideale Lösung für Ihren Traumbart.",
  ctaPrimary: "Kostenlose Beratung",
  ctaSecondary: "Kostenlose Beratung",
  badge: "Führende Spezialisten für Barthaartransplantation in NRW"
};

export const stats = [
  { value: "98%", label: "Zufriedene Patienten" },
  { value: "5.000+", label: "Erfolgreiche Behandlungen" },
  { value: "15+", label: "Jahre Erfahrung" },
  { value: "4.9★", label: "Google Bewertung" }
];

export const beforeAfterImages = [
  {
    id: 1,
    before: "/images/optimized/4jb5hpw9_image.webp",
    after: "/images/optimized/ggewgje9_image.webp",
    title: "Patient 1",
    grafts: "3.500 Grafts",
    technique: "DHI Methode"
  },
  {
    id: 2,
    before: "/images/optimized/adyjkke3_image.webp",
    after: "/images/optimized/hikx0a5q_image.webp",
    title: "Patient 2",
    grafts: "2.800 Grafts",
    technique: "DHI Methode",
    objectPosition: "center 20%"
  },
  {
    id: 3,
    before: "/images/optimized/fnab1x3a_image.webp",
    after: "/images/optimized/60uh91qc_image.webp",
    title: "Patient 3",
    grafts: "3.200 Grafts",
    technique: "DHI Methode"
  }
];

// Bartmuster mit typischen Grafts - spezifisch für Bartseite
export const beardPatterns = [
  {
    id: 1,
    title: "Kompletter Bart",
    description: "Umfassende Behandlung für einen vollständigen Bart mit optimaler Dichte",
    grafts: "3.000-4.000",
    sessions: "1-2 Sitzungen",
    image: "/images/Bart_komplett.webp"
  },
  {
    id: 2,
    title: "Dünner Bart",
    description: "Behandlung für spärlichen oder dünnen Bartwuchs zur Erhöhung der Dichte",
    grafts: "2.500-3.000",
    sessions: "1 Sitzung",
    image: "/images/Bart_undicht.webp"
  },
  {
    id: 3,
    title: "Bartkontur",
    description: "Präzise Definition der Bartlinien und Konturen",
    grafts: "500-1.000",
    sessions: "1 Sitzung",
    image: "/images/Bart_Kontur.webp"
  },
  {
    id: 4,
    title: "Bart mit Lücken",
    description: "Gezielte Behandlung von lückenhaften Bereichen im Bartwuchs",
    grafts: "500-1.000",
    sessions: "1 Sitzung",
    image: "/images/Bart_L%C3%BCcken.webp"
  }
];

export const expertise = [
  {
    id: 1,
    icon: "Users",
    title: "Erfahrenes Expertenteam",
    description: "Unser Team besteht aus hochqualifizierten Spezialisten mit jahrelanger Erfahrung in der Barthaartransplantation, die regelmäßig an Fortbildungen teilnehmen."
  },
  {
    id: 2,
    icon: "Sparkles",
    title: "Modernste Verfahren",
    description: "Wir setzen auf innovative Techniken wie Saphir-FUE und DHI, die präzisere Ergebnisse, schnellere Heilung und natürlicheres Aussehen ermöglichen."
  },
  {
    id: 3,
    icon: "Target",
    title: "Ganzheitliches Konzept",
    description: "Unser 360°-Ansatz umfasst nicht nur die Transplantation, sondern auch umfassende Analyse, Ernährungsberatung und ergänzende Behandlungen."
  },
  {
    id: 4,
    icon: "MessageSquare",
    title: "Individuelle Beratung",
    description: "Jeder Patient erhält einen maßgeschneiderten Behandlungsplan, der auf seine spezifischen Bedürfnisse, Bartstruktur und Wünsche abgestimmt ist."
  },
  {
    id: 5,
    icon: "HeartHandshake",
    title: "Langzeitnachsorge",
    description: "Wir begleiten Sie auch nach dem Eingriff mit regelmäßigen Kontrollterminen und unterstützenden Behandlungen für langfristig beste Resultate."
  },
  {
    id: 6,
    icon: "MapPin",
    title: "Keine Auslandsreise nötig",
    description: "Höchste medizinische Standards in Deutschland ohne Sprachbarrieren. Zentrale Lage in NRW, ideal erreichbar aus Köln und Düsseldorf."
  }
];

// Spezielle Techniken für Barthaartransplantation
export const techniques = [
  {
    id: 1,
    name: "Saphir-FUE-Technik",
    subtitle: "Spezialisierte Technik",
    description: "Die Saphir-FUE-Technik ist eine Weiterentwicklung der klassischen FUE-Methode, bei der spezielle Saphirklingen verwendet werden.",
    advantages: [
      "Präzisere Schnitte und geringere Gewebeschädigung",
      "Schnellere Heilung und weniger Schwellungen",
      "Höhere Anwuchsrate der transplantierten Haarfollikel",
      "Natürlicheres Erscheinungsbild der Barthaare"
    ],
    process: [
      "Entnahme einzelner Follikeleinheiten aus der Spenderzone",
      "Vorbereitung der Follikel unter dem Mikroskop",
      "Erstellung der Empfängerkanäle mit Saphirklingen",
      "Präzise Platzierung der Haarfollikel im Bartbereich"
    ],
    idealFor: "Schnelle Heilung, minimale Narben",
    image: "https://customer-assets.emergentagent.com/job_5a750e2c-9afa-457e-8878-f20f1025e07d/artifacts/876q7a14_saphir_fue.webp"
  },
  {
    id: 2,
    name: "DHI-FUE-Technik",
    subtitle: "Spezialisierte Technik",
    description: "Die DHI-Technik ermöglicht die direkte Implantation der Haarfollikel ohne vorherige Kanalerstellung.",
    advantages: [
      "Präzisere Kontrolle über Bartwuchsrichtung und -winkel",
      "Höhere Überlebensrate der Grafts durch minimale Manipulation",
      "Bessere Anpassung an die natürliche Bartstruktur",
      "Optimale Gestaltung der Bartkontur"
    ],
    process: [
      "Entnahme einzelner Follikeleinheiten aus der Spenderzone",
      "Direkte Ladung der Follikel in spezielle DHI-Implantationsstifte",
      "Präzise Implantation ohne vorherige Kanalerstellung",
      "Kontrolle über Tiefe, Winkel und Richtung der Implantation"
    ],
    idealFor: "Präzise Bartkonturierung, natürliche Wuchsrichtung",
    image: "https://customer-assets.emergentagent.com/job_5a750e2c-9afa-457e-8878-f20f1025e07d/artifacts/bp7s9vzb_dhi_fue.webp"
  }
];

export const processSteps = [
  {
    step: 1,
    title: "Kostenlose Beratung",
    description: "Vereinbaren Sie einen Termin für Ihre persönliche Bartanalyse - online oder vor Ort in unserem Standort in Mönchengladbach.",
    icon: "MessageSquare"
  },
  {
    step: 2,
    title: "Detaillierte Planung",
    description: "Wir analysieren Ihre Bartstruktur und besprechen die optimale Anzahl der Grafts sowie die gewünschte Bartform.",
    icon: "Sparkles"
  },
  {
    step: 3,
    title: "Die Behandlung",
    description: "Am Behandlungstag werden Sie von unserem erfahrenen Team betreut. Die Prozedur dauert je nach Umfang 3-6 Stunden unter lokaler Betäubung.",
    icon: "Stethoscope"
  },
  {
    step: 4,
    title: "Nachsorge",
    description: "Wir geben Ihnen detaillierte Pflegeanweisungen und sind für alle Ihre Fragen da. Regelmäßige Kontrolltermine sichern optimale Ergebnisse.",
    icon: "HeartHandshake"
  },
  {
    step: 5,
    title: "Das Ergebnis",
    description: "Nach 12-18 Monaten sehen Sie das vollständige Ergebnis: einen vollen, natürlich aussehenden Bart.",
    icon: "Trophy"
  }
];

// Behandlungsprozess mit Bildern (für visuelle Darstellung)
export const treatmentProcess = [
  {
    step: 1,
    title: "Planung",
    description: "In der Planungsphase wird die Bartkontur sorgfältig entworfen und die Anzahl der benötigten Grafts bestimmt. Eine detaillierte Analyse Ihrer Spenderzonen ermöglicht eine präzise und individuelle Planung.",
    image: "/images/Barthaartransplantation_Planung.svg"
  },
  {
    step: 2,
    title: "Entnahme",
    description: "Bei der Entnahme werden einzelne Haarfollikel aus der Spenderzone (meist am Hinterkopf) entnommen. Diese Follikeleinheiten werden sorgfältig unter dem Mikroskop vorbereitet.",
    image: "/images/Barthaartransplantation_Entnahme.svg"
  },
  {
    step: 3,
    title: "Einpflanzung",
    description: "Die vorbereiteten Haarfollikel werden präzise in die Empfängerzonen im Bartbereich eingesetzt. Dabei wird besonders auf den natürlichen Wuchswinkel geachtet.",
    image: "/images/Barthaartransplantation_Einpflanzung.svg"
  },
  {
    step: 4,
    title: "Endergebnis",
    description: "Nach 12-18 Monaten ist das endgültige Ergebnis sichtbar. Die transplantierten Barthaare wachsen natürlich und können wie Ihr eigener Bart gestylt werden.",
    image: "/images/Barthaartransplantation_Endergebnise.svg"
  }
];

// Expertise-Punkte für perfektes Ergebnis
export const expertisePoints = [
  {
    title: "Optimale Gestaltung der Bartkontur",
    description: "Wir gestalten die Bartkontur individuell passend zum Gesicht, unter Berücksichtigung von Gesichtsform, Alter und persönlichem Stil."
  },
  {
    title: "Unsichtbare Narben durch kleinste FUE Punches",
    description: "Durch modernste und kleinste FUE Punches hinterlassen wir praktisch unsichtbare Narben im Spenderbereich."
  },
  {
    title: "Minimale Schwellungen durch reduzierte Flüssigkeiten",
    description: "Wir verwenden nur geringe Mengen an Flüssigkeiten während des Eingriffs, um Schwellungen zu minimieren."
  },
  {
    title: "Präzise Platzierung für natürliche Übergänge",
    description: "Jedes Implantat wird präzise platziert, um natürliche Übergänge und die natürliche Bartwuchsrichtung zu respektieren."
  }
];

export const pricing = [
  {
    id: 1,
    name: "Barthaartransplantation",
    subtitle: "FUE Saphir & DHI kombiniert je nach Bedarf",
    features: [
      "Kombinierte FUE Saphir & DHI Technik",
      "Lokale Betäubung",
      "Individuelle Bartformgestaltung",
      "Nachsorgekit inklusive",
      "12 Monate Nachbetreuung"
    ],
    tiers: [
      { grafts: "bis 2.000 Grafts", price: "2.999" },
      { grafts: "bis 4.500 Grafts", price: "3.499" }
    ],
    popular: true,
    isBeardPricing: true,
    isSimplePricing: true,
    monthlyFrom: "53"
  }
];

export const team = [
  {
    id: 1,
    name: "Dr. Sotirios Tsomkopoulos",
    role: "Facharzt für Thoraxchirurgie & Haartransplantationschirurg",
    video: "https://customer-assets.emergentagent.com/job_themeswitch-2/artifacts/wmewma40_video%285%29.mp4",
    image: "https://customer-assets.emergentagent.com/job_5a750e2c-9afa-457e-8878-f20f1025e07d/artifacts/x1tzbzpk_sortiris.jpeg",
    description: "Dr. Tsomkopoulos ist Facharzt für Thoraxchirurgie mit Approbation in Deutschland und der Schweiz. Er verfügt über langjährige Erfahrung als leitender Haartransplantationschirurg in renommierten Kliniken.",
    specialization: "ISHRS-Mitglied, FUE & DHI Spezialist, Approbation DE/CH"
  },
  {
    id: 2,
    name: "Blerina Bevapi",
    role: "Fachärztin für Innere Medizin und Expertin für Haartransplantationen",
    video: "https://customer-assets.emergentagent.com/job_follicle-wizard/artifacts/if5w0ce2_bevapi.mp4",
    image: "/images/optimized/Blerina-Bevapi.webp",
    description: "Mit ihrer umfassenden medizinischen Expertise sorgt Dr. Bevapi für höchste medizinische Standards und optimale Behandlungsergebnisse bei Barthaartransplantationen.",
    specialization: "Fachärztin für Innere Medizin, Spezialisierung auf Haartransplantationstechniken"
  },
  {
    id: 3,
    name: "Dilek Ergüney",
    role: "Medizinische Haartechnikerin",
    video: "https://customer-assets.emergentagent.com/job_follicle-wizard/artifacts/i3r32fur_ergueney.mp4",
    image: "/images/optimized/Dilek-Ergueney.webp",
    description: "Dilek Ergüney bringt umfangreiche Erfahrung in der präzisen Durchführung von Barthaartransplantationen mit und ist spezialisiert auf die sorgfältige Handhabung von Haarfollikeln.",
    specialization: "Zertifizierte medizinische Haartechnikerin mit Spezialisierung auf FUE- und DHI-Techniken"
  },
  {
    id: 4,
    name: "Songül Bulut",
    role: "Spezialistin für Haartransplantationen",
    video: "https://customer-assets.emergentagent.com/job_follicle-wizard/artifacts/mvg2maej_bulut.mp4",
    image: "/images/optimized/Songuel-Bulut.webp",
    description: "Songül Bulut sammelte jahrelange Erfahrung in führenden Haarkliniken weltweit. Ihre internationale Expertise garantiert erstklassige Behandlungsergebnisse.",
    specialization: "Medizinstudium in der Türkei, internationale Erfahrung in führenden Haarkliniken"
  }
];

export const clinicImages = [
  {
    id: 1,
    src: "/images/optimized/DionHairClinic_Eingang.webp",
    alt: "Klinik Eingang",
    title: "Unsere Klinik"
  },
  {
    id: 2,
    src: "/images/optimized/DionHairClinic_Flur.webp",
    alt: "Klinik Flur",
    title: "Moderner Flur"
  },
  {
    id: 3,
    src: "/images/optimized/DionHairClinic_OP_Raum.webp",
    alt: "OP Raum",
    title: "Steriler OP-Raum"
  },
  {
    id: 4,
    src: "/images/optimized/DionHairClinic_Wartebereich.webp",
    alt: "Wartebereich",
    title: "Eleganter Wartebereich"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "David M.",
    location: "Köln",
    rating: 5,
    text: "Endlich kann ich mir einen Vollbart wachsen lassen! Vorher hatte ich überall Lücken. Das Ergebnis sieht absolut natürlich aus und ich fühle mich viel selbstbewusster.",
    image: "https://images.unsplash.com/photo-1677543167033-af3c688aa4df?w=100&h=100&fit=crop&auto=format",
    treatment: "Vollbart, 3.200 Grafts"
  },
  {
    id: 2,
    name: "Kevin S.",
    location: "Düsseldorf",
    rating: 5,
    text: "Die Bartkontur war immer mein Problem. Nach der Transplantation habe ich endlich scharfe, definierte Linien. Das Team war super professionell!",
    image: "https://images.unsplash.com/photo-1656338997878-279d71d48f6e?w=100&h=100&fit=crop&auto=format",
    treatment: "Bartkontur, 800 Grafts"
  },
  {
    id: 3,
    name: "Alexander T.",
    location: "Mönchengladbach",
    rating: 5,
    text: "Professionelle Beratung, tolles Ergebnis. Die DHI-Technik für den Bart ist wirklich beeindruckend. Die Wuchsrichtung sieht komplett natürlich aus!",
    image: "https://images.unsplash.com/photo-1656339781704-0afb3becfd90?w=100&h=100&fit=crop&auto=format",
    treatment: "Lückenfüllung, 1.500 Grafts"
  }
];

export const faqItems = [
  {
    question: "Kann ich eine Barthaartransplantation bekommen, wenn ich kaum Bartwuchs habe?",
    answer: "Ja, eine Barthaartransplantation ist auch für Männer mit wenig oder keinem natürlichen Bartwuchs möglich. Die Haarfollikel werden aus geeigneten Spenderzonen am Kopf entnommen und in die gewünschten Bereiche des Gesichts transplantiert. Das Ergebnis ist ein natürlich aussehender Bart, der nach Ihren Wünschen gestaltet werden kann."
  },
  {
    question: "Wie lange dauert der Eingriff?",
    answer: "Die Dauer hängt von der Anzahl der zu transplantierenden Grafts ab. In der Regel dauert eine Barthaartransplantation zwischen 3 und 6 Stunden. Bei größeren Transplantationen kann der Eingriff auf zwei Tage aufgeteilt werden."
  },
  {
    question: "Ist der Eingriff schmerzhaft?",
    answer: "Die Barthaartransplantation wird unter lokaler Betäubung durchgeführt, sodass Sie während des Eingriffs keine Schmerzen verspüren. Mit unserer innovativen DPI-Technologie (Dion Painless Injection) ist auch die Betäubungsphase nahezu schmerzfrei."
  },
  {
    question: "Wie lange dauert die Erholungsphase?",
    answer: "Die meisten Patienten können nach 1-2 Tagen wieder ihren normalen Aktivitäten nachgehen. Die Rötungen und Schwellungen klingen in der Regel innerhalb von 5-7 Tagen ab. Die vollständige Heilung dauert etwa 10-14 Tage."
  },
  {
    question: "Wann kann ich meinen Bart wieder rasieren oder trimmen?",
    answer: "Nach einer Barthaartransplantation sollten Sie für mindestens 14 Tage auf das Rasieren verzichten. Nach etwa 3 Wochen können Sie vorsichtig mit einer elektrischen Haarschneidemaschine trimmen. Nach 4-6 Wochen ist die vollständige Rasur wieder möglich."
  },
  {
    question: "Wann sehe ich die ersten Ergebnisse?",
    answer: "Die ersten neuen Barthaare beginnen nach etwa 3-4 Monaten zu wachsen. Das endgültige Ergebnis ist nach 12-18 Monaten sichtbar, wenn die transplantierten Haare vollständig gewachsen sind und ihre natürliche Dichte erreicht haben."
  },
  {
    question: "Wie lange hält das Ergebnis einer Barthaartransplantation?",
    answer: "Die transplantierten Barthaare sind dauerhaft, da sie aus Bereichen entnommen werden, die genetisch nicht für Haarausfall anfällig sind. Sie wachsen ein Leben lang wie normales Haar und können geschnitten, getrimmt und gestylt werden."
  },
  {
    question: "Gibt es Risiken oder Nebenwirkungen?",
    answer: "Wie bei jedem medizinischen Eingriff gibt es gewisse Risiken, die jedoch bei sachgemäßer Durchführung minimal sind. Mögliche Nebenwirkungen sind vorübergehende Schwellungen, Rötungen oder leichte Blutergüsse. Unser erfahrenes Team minimiert diese Risiken durch höchste Hygienestandards."
  },
  {
    question: "Werden die Kosten von der Krankenkasse übernommen?",
    answer: "In der Regel werden die Kosten nicht von den gesetzlichen Krankenkassen übernommen, da es sich um einen ästhetischen Eingriff handelt. Bei einigen privaten Krankenversicherungen kann eine teilweise Kostenübernahme möglich sein. Wir bieten verschiedene Finanzierungsmöglichkeiten an."
  },
  {
    question: "Wo befindet sich Ihre Klinik?",
    answer: "Unsere Klinik befindet sich in Mönchengladbach (Schürenweg 61, 41063) und ist ideal erreichbar aus Köln, Düsseldorf, dem Ruhrgebiet und den Niederlanden. Höchste medizinische Standards in Deutschland ohne Sprachbarrieren oder lange Reisen."
  }
];

export const features = {
  showAIAnalysis: false,
  analysisType: "beard",
  showPricing: true,
  showBeforeAfter: true,
  showTeam: true,
  showClinic: true,
  showBeardPatterns: true,
  showTechniques: true
};
